<template>
  <div>
    <div class="bg-light-gray rounded-bottom p-2">
      <div class="bg-white rounded py-4 px-5">
        <p class="font-16 mb-3">
          <i class="font-20 fas fa-info-circle mr-2 text-orange"></i>
          Información adicional
        </p>

        <div class="row">
          <div class="col-12">
            <label class="font-14 font-weight-normal text-muted mb-0">
              Descripción:
            </label>
            <p class="font-16 font-weight-normal">
              {{ messageError | empty }}
            </p>
          </div>
        </div>

        <div class="row mt-4">
          <div class="col-12 d-flex justify-content-end">
            <action-button
              @click="$emit('close')"
              i="fas fa-times-circle"
              variant="outline-danger"
              id="btn-search"
              text="Cerrar"
              class="mr-3"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ActionButton from 'ActionButton'
export default {
  name: 'MoreInformation',
  components: {
    ActionButton,
  },
  props: {
    messageError: {
      type: String,
      default: '',
    },
  },
}
</script>

<style lang="scss" scoped>
</style>
